import src from "IMAGE";
export default { src, width: 204, height: 52, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
